import React from "react";
import { AlertIcon } from "../../../../images/icons/icons";

const FormTextarea = ({ 
  icon: Icon, 
  label, 
  name, 
  placeholder, 
  value, 
  onChange, 
  error, 
  disabled = false,
  required = false,
  onRef,
  className = ""
}) => {
  const hasValue = (value) => {
    if (typeof value === 'string') return value.trim() !== '';
    return value !== null && value !== undefined && value !== '';
  };

  return (
    <div className={`staff-onboarding-form-group staff-onboarding-full-width ${className}`}>
      <label className="staff-onboarding-form-label">
        {Icon && <Icon color="#6B7280" />}
        <span className="staff-onboarding-label-text">
          {label} {required && <span className="staff-onboarding-required">*</span>}
        </span>
      </label>
      <div className={`staff-onboarding-textarea-wrapper ${error ? "error" : ""} ${disabled ? "disabled" : ""}`}>
        <textarea
          ref={onRef}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`staff-onboarding-textarea ${hasValue(value) ? 'has-value' : ''}`}
          rows={3}
        />
        {error && (
          <div className="staff-onboarding-error-message">
            <AlertIcon color="#EF4444" />
            <span>{error}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormTextarea;
